import * as React from 'react';

// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Radio from '@material-ui/core/Radio';
// import RadioGroup from '@material-ui/core/RadioGroup';

import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

import {LocationData} from './routeSelector';
import Button from '@material-ui/core/Button';



export interface ClientLocationMngProps {
    clientDocument: string|undefined;
    locationList: LocationData[]|undefined;
    onChange:(e:any) => any ;
}

export interface ClientLocationMngState {
    // locationList: LocationData[]|undefined;
    selectedIndex: number;
}



export class ClientLocationMng extends React.Component<ClientLocationMngProps, ClientLocationMngState>{


    constructor(props: ClientLocationMngProps) {
        super(props);
        this.state = {
            selectedIndex: 0,
        };
        this.handleChange=this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    handleChange(index: number )  {
        this.props.onChange(index);

        this.setState({selectedIndex:index});
        console.log(this.state.selectedIndex);

    };

    handleClick(id: number){
        console.log("id:" + id);
    }

    shouldComponentUpdate(nextProps: any, nextState:any) {
        if (this.props.locationList &&  this.props.locationList[0] &&  this.props.locationList[0].id === nextProps.locationList[0].id) {
          return false;
        } else {
          return true;
        }
    }

    
    render() {

         const locations = this.props.locationList && this.props.locationList.map((location, index) =>
         <Button color="primary" onClick={()=>this.handleChange(index)} key={index}>#{location.id} {location.street1}{}</Button> );

        
        return (
            <div>
            <div>{this.props.locationList && this.props.locationList[0] && this.props.locationList[0].client.user.name}</div>


            <FormControl component="fieldset">
                <FormLabel component="legend">Direcciones del cliente</FormLabel>
                <Button color="primary" onClick={()=>this.handleChange(-1)} key="-1">Es una nueva dirección</Button>
                {locations}
            </FormControl>
            </div>
        );

    }
}


// WEBPACK FOOTER //
// ./src/components/ClientLocationMng.tsx